import { render, staticRenderFns } from "./RedeemGift.vue?vue&type=template&id=6e5ec036&scoped=true&"
import script from "./RedeemGift.vue?vue&type=script&lang=js&"
export * from "./RedeemGift.vue?vue&type=script&lang=js&"
import style0 from "./RedeemGift.vue?vue&type=style&index=0&id=6e5ec036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5ec036",
  null
  
)

export default component.exports